<template>
  <div class="app-wrapper">
    <div class="header-container">
      <audio id="myAudio" src="https://czg-wx.oss-cn-hangzhou.aliyuncs.com/audio/dd.mp3" preload="auto"></audio>
      <div
        class="header-container--logo layoutLogo"
        :style="{ width: dataScreenWidth }"
        v-if="personalData.tenantLogo == ''"
      >
        <router-link to="/">
          <img :src="personalData.tenantLogo || require('@/assets/image/logo-s.png')" alt="" v-if="asideCollapse" />
          <img :src="personalData.tenantLogo || require('@/assets/image/logo-a.png')" v-else />
        </router-link>
      </div>
      <div class="header-container--logo layoutLogo" :style="{ width: '170px' }" v-else>
        <router-link to="/">
          <img :src="personalData.tenantLogo || require('@/assets/image/logo-a.png')" alt="" />
        </router-link>
      </div>
      <div class="header-container--title">
        {{ personalData.upTitle || '智能车队管理系统政企版' }}
      </div>
      <div class="header-right">
        <header-alarm v-action:alarm :count="alarmCount"></header-alarm>
        <header-message :count="msgCount"></header-message>
        <el-dropdown>
          <el-button class="btn-text can-hover header-avatar" type="text" style="font-size: 14px; color: #fff">
            {{ loginName }}
            <i class="iconfont iconcaidan-youshangjiaoxiala" style="font-size:14px;color:#fff" />
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="winVisible = true">修改密码</el-dropdown-item>
            <el-dropdown-item @click.native="loginOut">注销登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 侧边导航栏 -->
    <div class="sidebar-container" :style="{ width: asideWidth }">
      <div class="menu-btn" :class="{ on: asideCollapse }" @click="CHANGE_COLLAPSE(!asideCollapse)">
        <span><i class="iconfont icon-iconcaidan-menuZhan" style="font-size: 13px"></i></span>
      </div>
      {{ layoutStatus && asideCollapse }}
      <aside-menu :asideCollapse="asideCollapse" />
    </div>
    <!-- 内容主体 -->
    <div class="main-container" :style="{ left: asideWidth }">
      <div class="page-view" id="page-view">
        <router-view />
      </div>
    </div>
    <el-dialog
      width="500px"
      class="redefine-dialog"
      title="修改密码"
      :visible.sync="winVisible"
      @close="cancel"
      :close-on-click-modal="false"
    >
      <div style="margin-top:20px;width:90%">
        <el-form
          ref="formData"
          status-icon
          :rules="rules"
          :model="formData"
          label-width="120px"
          label-position="right"
          :show-message="false"
        >
          <el-form-item label="原密码：" :required="true" prop="oldPsw">
            <el-input type="password" v-model="formData.oldPsw" maxlength="30" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="新密码：" :required="true" prop="newPsw">
            <el-input type="password" v-model="formData.newPsw" maxlength="30" size="mini"></el-input>
          </el-form-item>
          <el-form-item label="确认密码：" :required="true" prop="newPsw1">
            <el-input type="password" v-model="formData.newPsw1" maxlength="30" size="mini"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="default" @click="cancel()" size="mini">取消</el-button>
        <el-button type="primary" @click="save()" size="mini">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'

export default {
  data() {
    var checkAge = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('年龄不能为空'))
      }
      callback()
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (this.formData.newPsw1 !== '') {
          this.$refs.formData.validateField('newPsw1')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formData.newPsw) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      personalData: {},
      logoA: '',
      winVisible: false,
      formData: {},
      socket: null,
      rules: {
        newPsw: [{ validator: validatePass, trigger: 'blur' }],
        newPsw1: [{ validator: validatePass2, trigger: 'blur' }],
        oldPsw: [{ validator: checkAge, trigger: 'blur' }],
      },
      msgCount: 0,
      alarmCount: 0,
      personalData: {},
    }
  },
  computed: {
    asideWidth() {
      return this.$store.getters.asideCollapse ? '64px' : '170px'
    },
    dataScreenWidth() {
      return this.asideCollapse ? '64px' : '170px'
    },
    loginName() {
      return this.$ls.get('userName')
    },
    tenantName() {
      return this.$ls.get('tenantName')
    },
    layoutStatus() {
      return this.$route.path != '/dataScreen'
    },
    ...mapGetters(['asideCollapse', 'websocket', 'alarmMsgCount', 'unreadCount']),
  },
  beforeMount() {
    this.getDictlist()
  },
  watch: {
    alarmMsgCount(val) {
      this.alarmCount = val
    },
    unreadCount(val) {
      this.msgCount = val
    },
  },
  created() {
    this.personalData = this.$ls.get('personalSetting') || {}
  },
  mounted() {
    this.personalData = this.$ls.get('personalSetting') || {}
    const wrapperWidth = document.getElementById('page-view').clientWidth - 330
    this.CHANGE_SEARCHLEN(parseInt(wrapperWidth / 253))
    const that = this
    window.onresize = function temp() {
      let newWrapper = document.getElementById('page-view').clientWidth - 330
      that.CHANGE_SEARCHLEN(parseInt(newWrapper / 253))
    }
    // console.log(this.websocket)
    // this.getMessageCount()
    this.getAlarmUnread()
    this.getRenew()
    this.unreadCountHandler()
  },
  components: {
    'aside-menu': () => import('@/components/asideMenu'),
    'header-message': () => import('./components/header-message'),
    'header-alarm': () => import('./components/header-alarm'),
  },
  methods: {
    ...mapMutations([
      'CHANGE_SEARCHLEN',
      'CHANGE_CAUSEOPT',
      'CHANGE_CARTYPE',
      'CHANGE_COLLAPSE',
      'STAFF_UPDATEPOSDATA',
      'STAFF_UPDATEMULTDATA',
      'changeIsSubmitted',
    ]),
    // async getMessageCount() {
    //   const data = await this.$api.getUnreadnum()
    //   if (data.success) {
    //     this.msgCount = data.datas.content.taskCount
    //   }
    // },
    async getRenew() {
      this.$ls.set('isSubmitted', false)
      let isSubmitted = false
      const data = await this.$api.getRenewList({ pageSize: 99, expireDateType: 1 })
      if (data.success) {
        data.datas.content.forEach((i) => {
          if (i.isSubmitted == 0) {
            isSubmitted = true
          }
        })
        if (isSubmitted) {
          this.changeIsSubmitted(true)
        } else {
          this.changeIsSubmitted(false)
        }
      }
    },
    async getAlarmUnread() {
      const data = await this.$api.getUnreadAlarm()
      if (data.success) {
        this.alarmCount = data.datas.content
      }
    },
    getDictlist() {
      this.$api
        .getDictlist({
          dictCode: 'carOrderCause',
        })
        .then((res) => {
          if (res.success) {
            this.CHANGE_CAUSEOPT(res.datas.content)
          }
        })
      this.$api
        .getDictlist({
          dictCode: 'carType',
        })
        .then((res) => {
          if (res.success) {
            this.CHANGE_CARTYPE(res.datas.content)
          }
        })
    },
    async loginOut(command) {
      const data = await this.$api.loginOut()
      this.$ls.remove('token')
      this.$ls.remove('userName')
      this.$ls.remove('socketClientID')
      // 跳转路由
      window.location.reload()
    },
    cancel() {
      this.winVisible = false
      this.$refs.formData.resetFields()
    },
    save() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          const data = await this.$api.modifyPsw(this.formData)
          if (data.success) {
            this.cancel()
            this.$message.success('密码成功！请重新登录')
            this.loginOut()
          }
        }
      })
    },
    async unreadCountHandler() {
      const data = await this.$api.noticeRemind({
        pageSize: 1,
        pageNum: 1,
        ifRead: 0,
      })

      if (data.success) {
        this.msgCount = data.datas.total
      }
    },
  },
}
</script>

<style lang="scss">
.app-wrapper {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  overflow: hidden;
  .header-container {
    display: flex;
    height: 50px;
    background-color: #fff;
    box-shadow: 0 2px 10px 0 #cdd2d1;
    background-color: #2cac85;
    background-image: url('~@/assets/image/headBottom.png');
    background-position: left center;
    &--logo {
      width: 170px;
      // background: #33373e;
      text-align: center;
      line-height: 50px;
      z-index: 999;
      border-right: 1px solid #80cdb5;
      img {
        vertical-align: middle;
        max-height: 25px;
        max-width: 100%;
      }
    }
    &--title {
      font-size: 16px;
      color: #fff;
      letter-spacing: 0;
      display: inline-block;
      margin-left: 20px;
      height: 50px;
      line-height: 50px;
    }
    .header-right {
      flex: 1;
      text-align: right;
      margin-top: 2px;
      display: flex;
      width: 100%;
      justify-content: flex-end;
      -ms-flex-align: center;
      align-items: center;
      padding-right: 20px;
      sup {
        border: none;
        background-color: #ff4d4f;
      }
      .el-dropdown {
        position: relative;
        margin-left: 20px;
        &::before {
          content: '';
          display: inline-block;
          position: absolute;
          background: #979797;
          opacity: 0.3;
          width: 1px;
          left: 0;
          top: 50%;
          transform: translateY(-50%);
          height: 20px;
        }
      }
    }
  }
  .sidebar-container {
    background: #33373e;
    position: absolute;
    top: 50px;
    bottom: 0;
    left: 0;
    font-size: 0;
    //overflow: hidden;
    box-sizing: border-box;
    .menu-btn {
      width: 100%;
      height: 40px;
      line-height: 40px;
      cursor: pointer;
      color: rgba(255, 255, 255, 0.8);
      text-align: center;
      background: #2b2e34;
      transition: width linear 0.2s;
      .iconfont {
        font-size: 12px;
      }
      span {
        width: 20px;
        height: 20px;
        display: inline-block;
        text-align: center;
        line-height: 20px;
        vertical-align: middle;
        transform: rotate(0deg);
        position: relative;
        left: -2px;
      }
      &.on {
        // width:60px;
        span {
          transform: rotate(90deg);
        }
      }
    }
    .scrollbar-wrapper {
      height: calc(100% - 40px);
      overflow-x: hidden !important;
    }
    .el-menu {
      background-color: transparent;
      border-right: none;
      .el-menu-item {
        color: #fff;
        i {
          font-size: 16px;
        }
      }
    }
    .el-scrollbar__wrap {
      overflow-x: hidden;
    }
  }
  .main-container {
    position: absolute;
    top: 50px;
    right: 0px;
    bottom: 0px;
    background: #f0f0f0;
    overflow: hidden;
    .page-view {
      height: 100%;

      overflow: hidden;
    }
  }
}
</style>
